import { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";

import transportHero from "../../assets/Transportation.jpg";

import trans1 from "../../assets/Toyota Axio.jpg";
import trans2 from "../../assets/toyota-kdh-highroof.jpg";
import trans3 from "../../assets/KING-LONG-bus.jpg";

function Transportation() {
    const [activeImage, setActiveImage] = useState(trans1);

    useEffect(() => {
        AOS.init({ duration: 1000, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO ================= */}
            <section className="relative h-[40vh] w-full">
                <div
                    className="absolute inset-0 bg-cover bg-center"
                    style={{ backgroundImage: `url(${transportHero})` }}
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white">
                    <h1
                        data-aos="fade-up"
                        className="text-3xl sm:text-4xl md:text-5xl lg:text-4xl font-extrabold leading-tight"
                    >
                        Transportation
                    </h1>

                    <p
                        data-aos="fade-up"
                        data-aos-delay="150"
                        className="mt-4 sm:mt-6 max-w-full sm:max-w-2xl md:max-w-3xl text-sm sm:text-base md:text-lg"
                    >
                        Seamless Travel Across Sri Lanka with Kurumba Holidays
                    </p>
                </div>
            </section>

            {/* ================= TRANSPORTATION SECTION ================= */}
            <section className="bg-white py-16 px-4 sm:px-8 lg:px-20">
                <div className="max-w-7xl mx-auto">

                    {/* Title */}
                    <h2
                        data-aos="fade-up"
                        className="text-center text-2xl sm:text-3xl md:text-4xl font-semibold text-blue-900 tracking-wide"
                    >
                        Comfortable & Reliable Transport Options
                    </h2>

                    {/* Content */}
                    <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                        {/* Text Content */}
                        <div data-aos="fade-right" className="space-y-5 text-gray-700 text-sm sm:text-base leading-relaxed">

                            <p>
                                At Kurumba Holidays Sri Lanka, we offer a range of tailored transportation services
                                to meet your travel needs — whether you’re exploring the island’s cultural treasures
                                or heading to your resort in comfort.
                            </p>

                            <p>
                                Choose from private cars, luxury vans, minibuses, air-conditioned coaches and
                                chauffeur-driven transfers. Our professional drivers ensure safe and punctual travel
                                throughout your journey.
                            </p>

                            <p>
                                From airport pickups and drop-offs to multi-day road tours and scenic drives, we
                                take care of all logistics so you can relax and enjoy the experience.
                            </p>

                            <p>
                                Whether you’re a solo traveler, family group or corporate delegation, our fleet
                                adapts to your itinerary for stress-free transportation anywhere in Sri Lanka.
                            </p>

                        </div>

                        {/* Image Section */}
                        <div data-aos="fade-left" className="relative">

                            {/* Main Image */}
                            <img
                                src={activeImage}
                                alt="Transportation Sri Lanka"
                                className="rounded-lg shadow-xl w-full h-[350px] object-cover transition duration-300"
                            />

                            {/* Thumbnail Strip */}
                            <div className="flex gap-3 mt-4 justify-center">
                                {[trans1, trans2, trans3].map((img, index) => (
                                    <img
                                        key={index}
                                        src={img}
                                        onClick={() => setActiveImage(img)}
                                        className={`w-20 h-14 object-cover rounded-md shadow cursor-pointer transition
                                        ${activeImage === img
                                                ? "ring-2 ring-blue-600 scale-105"
                                                : "opacity-70 hover:opacity-100"
                                            }`}
                                        alt="thumbnail"
                                    />
                                ))}
                            </div>

                        </div>

                    </div>
                </div>
            </section>

            {/* ================= WHATSAPP BUTTON ================= */}
            <a
                href="https://wa.me/94743412910"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
                />
            </a>

        </div>
    );
}

export default Transportation;
